<template>
  <div class="nutrition-traffic-lights">
    <div id="traffic-lights">
      <div
        class="traffic-light col-md-3"
      >
				<div :class="{ red: (totalFat >= 20), amber: (totalFat > 3 && totalFat < 20), green: (totalFat <= 3) }">
					<span class="title">Fat</span>
					<div class="values">{{totalFat}} g</div>
					<div
						class="percentage"
					>{{ totalFat_lmh }}</div>
				</div>
      </div>
      <div class="traffic-light col-md-3">
				<div :class="{ red: (saturatedFat >= 5), amber: (saturatedFat > 1.5 && saturatedFat < 5), green: (saturatedFat <= 1.5) }">
					<span class="title">Saturates</span>
					<div class="values">{{saturatedFat}} g</div>
					<div
						class="percentage"
					>{{ saturatedFat_lmh }}</div>
				</div>
      </div>
      <div class="traffic-light col-md-3">
				<div :class="{ red: (sugars >= 22.5), amber: (sugars > 5 && sugars < 22.5), green: (sugars <= 5) }">
					<span class="title">Sugars</span>
					<div class="values">{{sugars}} g</div>
					<div class="percentage">{{ sugars_lmh }}</div>
				</div>
			</div>
      <div class="traffic-light col-md-3">
				<div :class="{ red: (sodium >= 1500), amber: (sodium > 300 && sodium < 1500), green: (sodium <= 300) }">
					<span class="title">Salt</span>
					<div class="values">{{sodium}} mg</div>
					<div class="percentage">{{sodium_lmh}}</div>
				</div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../services/api.js";
import { mapMutations } from "vuex";

export default {
  components: {},
  props: [
    "calories",
    "totalFat",
    "saturatedFat",
    "sugars",
    "sodium",
    "energyKj"
	],
	watch: { 
			calories: function(newVal, oldVal) { // watch it
				this.calculatePercentages()
			},
			totalFat: function(newVal, oldVal) { // watch it
				this.calculatePercentages()
			},
			saturatedFat: function(newVal, oldVal) { // watch it
				this.calculatePercentages()
			},
			sugars: function(newVal, oldVal) { // watch it
				this.calculatePercentages()
			},
			sodium: function(newVal, oldVal) { // watch it
				this.calculatePercentages()
			},
			energyKj: function(newVal, oldVal) { // watch it
				this.calculatePercentages()
			},
		},
  data() {
    return {
			saturatedFat_lmh: "",
			totalFat_lmh: "",
			sugars_lmh: "",
			sodium_lmh: "",
		};
	},
  created() {
		this.calculatePercentages();
  },
  methods: {
		calculatePercentages: function() {
			//Sugars
			if (this.sugars < 15) {
				this.sugars_lmh = "Low";
			}
				
			if (this.sugars > 5 && this.sugars < 15) {
				this.sugars_lmh = "Med";
			}
				
			if (this.sugars > 15) {
				this.sugars_lmh = "High";
			}

			//totalFat
			if (this.totalFat <= 3) {
				this.totalFat_lmh = "Low";
			}
				
			if (this.totalFat > 3 && this.totalFat < 20) {
				this.totalFat_lmh = "Med";
			}
				
			if (this.totalFat >= 20) {
				this.totalFat_lmh = "High";
			}

			//saturatedFat
			if (this.saturatedFat < 5) {
				this.saturatedFat_lmh = "Low";
			}
				
			if (this.saturatedFat > 1.5 && this.saturatedFat < 5) {
				this.saturatedFat_lmh = "Med";
			}
				
			if (this.saturatedFat > 5) {
				this.saturatedFat_lmh = "High";
			}

			//sodium
			if (this.sodium <= 120) {
				this.sodium_lmh = "Low";
			}
				
			if (this.sodium > 120 && this.sodium < 600) {
				this.sodium_lmh = "Med";
			}
				
			if (this.sodium >= 600) {
				this.sodium_lmh = "High";
			}
		}
	}
};
</script>

<style scoped>
.traffic-light {
  padding-top: 1px;
  padding-bottom: 5px;
}

.traffic-light .values {
  padding: 20px;
  font-weight: bold;
}

.traffic-light .percentage {
  padding: 5px;
	color: #444;
	font-size: 11px;
  font-weight: bold;
	background: #fff;
	margin: 0 20px;
	border-radius: 10px;
}

#traffic-lights {
  margin: 0 auto;
	text-align: center;
}

.traffic-light .red {
  background-color: #d2232a;
  border-color: rgb(133, 12, 16);
	color: #fff;
	display: inline-block;
  text-align: center;
  border: 2px solid #888;
  min-height: 90px;
  margin-bottom: 20px;
  vertical-align: middle;
	border-radius: 10px;
	padding-top: 10px;
	padding-bottom: 5px;
	width: 100%;
}


.traffic-light .amber {
  background-color: #f7941d;
  border-color: rgb(190, 111, 14);
	color: #fff;
	display: inline-block;
  text-align: center;
  border: 2px solid #888;
  min-height: 90px;
  margin-bottom: 20px;
  vertical-align: middle;
	border-radius: 10px;
	padding-top: 10px;
	padding-bottom: 5px;
	width: 100%;
}


.traffic-light .green {
  background-color: #42ac48;
  border-color: rgb(14, 117, 19);
	color: #fff;
	display: inline-block;
  text-align: center;
  border: 2px solid #888;
  min-height: 90px;
  margin-bottom: 20px;
  vertical-align: middle;
	border-radius: 10px;
	padding-top: 10px;
	padding-bottom: 5px;
	width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/common/TrafficLights.vue